module.exports = __webpack_public_path__ + "img/hir_yes.9cc5e8bd.png";